import {
    mapState, mapMutations, mapActions, mapGetters,
} from 'vuex';
import _ from 'lodash';
import ChanceJS from 'chance';

import questionSelectStage from '@/mixins/questionSelectStage';
import PopupWrapper from '@/components/Wrapper/InstructionPopupWrapper.vue';
import TimeCounter from '@/components/Stage/Game/Components/TimeCounter.vue';
import Score from '@/components/Stage/Game/Components/Score.vue';
import Footer from '@/components/Stage/Game/Components/Footer.vue';
import AnswerWrapper from '@/components/Stage/Game/Components/AnswerWrapper.vue';
import GlobalConfig from '@/config/global';

const Chance = new ChanceJS();

export default {
    mixins: [questionSelectStage],
    components: {
        PopupWrapper,
        TimeCounter,
        Score,
        Footer,
        AnswerWrapper,
    },
    data() {
        return {
            popup: true,
            score: 0,
            answeredQuestionAmount: 0,
            questionConfig: {},
            questionWeight: [],
            selected: undefined,
            correct: undefined,
            bonusCountdown: false,
            restTime: 0,
            questionPool: undefined,
        };
    },
    created() {
        this.initQuestionPool();
    },
    computed: {
        ...mapState({
            questionSet: 'questionSet',
            answerCorrectedSet: 'answerCorrectedSet',
        }),
        ...mapGetters({
            getGameQuestionAmount: 'config/getGameQuestionAmount',
        }),
        level() {
            return this.$route.params.level;
        },
        duration() {
            return this.config[`level${this.level}`].duration;
        },
        correctScore() {
            return this.config[`level${this.level}`].correctScore;
        },
        totalQuestions() {
            const GAME = this.$route.params.type;
            return this.getGameQuestionAmount(GAME);
        },
    },
    methods: {
        ...mapMutations({
            setScore: 'setScore',
            updateCorrectSet: 'updateCorrectSet',
            updateIncorrectSet: 'updateIncorrectSet',
            updateReviewQuestionSet: 'updateReviewQuestionSet',
        }),
        ...mapActions({
            handleGameOver: 'handleGameOver',
        }),
        initQuestionPool() {
            let POOL = this.questionSet;
            let WEIGHT;
            const QUESTION_POOL = [];
            WEIGHT = [...this.setWeight(POOL)];
            console.log(this.totalQuestions, 'test');
            for (let i = 0; i < this.totalQuestions; i += 1) {
                const SELECTED = Chance.weighted(POOL, WEIGHT);
                POOL = _.filter(POOL, (o) => o !== SELECTED);
                WEIGHT = [...this.setWeight(POOL)];
                QUESTION_POOL.push(SELECTED);
            }
            this.questionPool = [...QUESTION_POOL];
            this.updateReviewQuestionSet(QUESTION_POOL);
        },
        setWeight(pool) {
            const ANSWERED = [];
            pool.forEach((item) => {
                const FOUND = _.find(this.answerCorrectedSet, (o) => o === item.id);
                if (FOUND) ANSWERED.push(1);
                else ANSWERED.push(5);
            });
            return ANSWERED;
        },
        onReady() {
            this.popup = false;
            this.$refs.timeCounter.onStart();
            this.questionConfig = this.questionPool.pop();
            this.startBonusCountdown();
        },
        async onDue(bonus) {
            const BONUS_SCORE = Math.floor((bonus || 0) / GlobalConfig.bonusExchangeConstant);
            this.setScore(this.score + BONUS_SCORE);
            const game = this.$route.params.type.replace(/game/, '');
            const { level } = this.$route.params;
            await this.handleGameOver({ game, level, answerTime: this.duration - bonus });
            this.$router.push({ name: 'Stage_Result' });
        },
        onTick(time) {
            this.restTime = time;
        },
        onChangeQuestion(delay) {
            setTimeout(() => {
                if (this.questionPool.length === 0) {
                    this.onDue(this.restTime);
                } else {
                    this.bonusCountdown = true;
                    this.correct = undefined;
                    this.selected = undefined;
                    this.questionConfig = this.questionPool.pop();
                    this.startBonusCountdown();
                }
            }, delay || 1000);
        },
        startBonusCountdown() {
            setTimeout(() => {
                this.bonusCountdown = false;
            }, 1000);
        },
        handleAfterAnswer(isCorrect) {
            if (isCorrect) {
                this.score += this.bonusCountdown ? this.correctScore * 2 : this.correctScore;
                this.updateCorrectSet(this.questionConfig.id);
            } else this.updateIncorrectSet(this.questionConfig.id);
        },
    },
};
